import React from 'react'
import PropTypes from 'prop-types'
import { IconLoginGrey, TextCaption2 } from '@blocket/blocket-ui'
import { UserInfoSection, Info, IllustrativeContainer, Name, IconVerified } from './styling'

const ProfileCard = ({
  profileName,
  account = {},
  showVerificationInfo = true,
  maskForHotjar = false,
}) => {
  const { isVerified, verifiedWith, onBlocketSince } = account

  return (
    <UserInfoSection>
      <IllustrativeContainer>
        <IconLoginGrey width={64} height={64} />
        {showVerificationInfo && isVerified && <IconVerified width={24} height={24} />}
      </IllustrativeContainer>
      <Info>
        {/* the 'data-hj-suppress' attribute is used to mask sensitive info from Hotjar, do not remove */}
        <Name tagName="h1" data-hj-suppress={maskForHotjar}>
          {profileName}
        </Name>
        {onBlocketSince && <TextCaption2>{onBlocketSince}</TextCaption2>}
        {showVerificationInfo && verifiedWith && <TextCaption2>{verifiedWith}</TextCaption2>}
      </Info>
    </UserInfoSection>
  )
}

ProfileCard.propTypes = {
  profileName: PropTypes.string,
  account: PropTypes.object,
  showVerificationInfo: PropTypes.bool,
  maskForHotjar: PropTypes.bool,
}

export default ProfileCard
